// library vue-clipboard2 사용
export function copyText(text){
    this.$copyText(text)
    // alert(text+'복사')
}